export default __webpack_public_path__ + "static/media/poisn.415169ba.jfif";